export default {"src":"/_next/static/media/mysql_logo_06b69f9930.befe9de5.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};